import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FilterContext } from '../../context/FilterContext';
import { Button } from '../Common/Button';
import ActivityCard from './ActivityCard';
import { clearQueue } from '../../services/travelTimeQueue';

const GridView = ({ activities }) => {
  const navigate = useNavigate();
  const { filters } = useContext(FilterContext);
  const itemsPerPage = 24; // Teilbar durch 1, 2, 3, 4 für volle Reihen
  const savedCount = parseInt(sessionStorage.getItem('gridVisibleCount') || '0', 10);
  const [visibleCount, setVisibleCount] = useState(savedCount > itemsPerPage ? savedCount : itemsPerPage);

  const paginatedActivities = activities.slice(0, visibleCount);
  const remaining = activities.length - visibleCount;
  const nextLoadCount = Math.min(itemsPerPage, remaining);

  // Scroll-Position nach Rückkehr von Detailseite wiederherstellen
  useEffect(() => {
    const savedY = sessionStorage.getItem('homeScrollY');
    if (savedY) {
      sessionStorage.removeItem('homeScrollY');
      sessionStorage.removeItem('gridVisibleCount');
      requestAnimationFrame(() => window.scrollTo({ top: parseInt(savedY, 10), behavior: 'instant' }));
    }
  }, []);

  // Setze sichtbare Aktivitäten zurück wenn Filter geändert werden
  useEffect(() => {
    setVisibleCount(itemsPerPage);
  }, [filters]);

  const handleActivityClick = (activity) => {
    clearQueue();
    sessionStorage.setItem('homeScrollY', String(window.scrollY));
    sessionStorage.setItem('gridVisibleCount', String(visibleCount));
    // Füge Filterdatum als URL-Parameter hinzu, falls gesetzt
    const params = new URLSearchParams();
    if (filters.departure_date) {
      params.set('date', filters.departure_date);
    }
    if (activity.active_time?.start_time) {
      params.set('time', activity.active_time.start_time);
    }
    const queryString = params.toString();
    navigate(`/activities/${activity.id}${queryString ? '?' + queryString : ''}`);
  };

  return (
    <div className="grid-view-container">
      <div className="grid-view">
        {paginatedActivities.length === 0 && (
          <div style={{ padding: '40px', textAlign: 'center', color: '#666' }}>
            Keine Aktivitäten gefunden
          </div>
        )}
        {/* Aktivitäten-Karten */}
        {paginatedActivities.map((activity, index) => (
          <ActivityCard 
            key={`${activity.id}_${index}`} 
            activity={activity} 
            onActivityClick={handleActivityClick}
          />
        ))}
      </div>

      {/* Mehr laden */}
      {remaining > 0 && (
        <div className="load-more-container">
          <Button
            className="load-more-button"
            onClick={() => setVisibleCount(prev => prev + itemsPerPage)}
            variant="outline"
            style={{ padding: '8px 16px' }}
          >
            Mehr laden ({nextLoadCount})
          </Button>
        </div>
      )}
    </div>
  );
};

export default GridView;
